export const MODAL_VISIBILITY = 'MODAL_VISIBILITY';
